module.exports = __webpack_public_path__ + "static/media/6.dc709832.jpg";